import React from 'react';
import { useMantineColorScheme } from '@mantine/core';
import { useAppSelector } from '@/store/store.hooks';
import { selectSessionUser } from '@/store/auth/auth.selectors';
import { useUpdatePreferencesMutation } from '@/store/api/profile/profile.api';
import type { TypeUserPreferences } from '@/types/auth/types.auth.session';

export const useAppearance = () => {
    const user = useAppSelector(selectSessionUser);
    const { setColorScheme } = useMantineColorScheme();
    const [save, { isLoading }] = useUpdatePreferencesMutation();

    const preferences = user?.preferences ?? null;

    React.useEffect(() => {
        if (!preferences) return;
        setColorScheme(preferences.theme === 'system' ? 'auto' : preferences.theme);
        document.documentElement.dataset.bdDensity = preferences.density;
    }, [preferences?.theme, preferences?.density]); // eslint-disable-line react-hooks/exhaustive-deps

    const change = (patch: Partial<TypeUserPreferences>) => {
        if (!preferences) return;
        const next = { ...preferences, ...patch };

        if (patch.theme) setColorScheme(patch.theme === 'system' ? 'auto' : patch.theme);
        if (patch.density) document.documentElement.dataset.bdDensity = patch.density;

        void save(next);
    };

    return { preferences, change, saving: isLoading };
};

export default useAppearance;
